module.exports = __webpack_public_path__ + "img/emoji_166.7d739ebb.png";